import { useEffect, useId } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { cn } from "@/lib/utils";
import { blockPopups, unblockPopups } from "@/lib/launchPopups";

const block = (e) => e.preventDefault();

// Slide-up that cannot be swiped, tapped or escaped away — only the actions inside close it.
// Sits above launch popups (location / push) and holds them back while open.
export default function PersistentSheet({ open, title, icon: Icon, children, testId, className }) {
  const id = useId();
  useEffect(() => {
    if (!open) return undefined;
    const name = `request-sheet:${id}`;
    blockPopups(name);
    return () => unblockPopups(name);
  }, [open, id]);
  return (
    <Dialog open={open} onOpenChange={() => {}}>
      <DialogContent
        hideCloseButton
        draggable={false}
        className={cn("max-w-md z-[1250]", className)}
        data-testid={testId}
        onPointerDownOutside={block}
        onInteractOutside={block}
        onEscapeKeyDown={block}
      >
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-[#4F988E]" data-testid={testId ? `${testId}-title` : undefined}>
            {Icon && <Icon size={20} />}
            {title}
          </DialogTitle>
        </DialogHeader>
        {children}
      </DialogContent>
    </Dialog>
  );
}
